import logging from '@wr/logging';
import {getCsrf, getLanguageCode} from './selectors';
import config from '../config';


const sendWebVitalReport = (metric, state) => {
    const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);
    fetch(`/${getLanguageCode(state)}/payment-providers/api/metric`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'csrf-token': getCsrf(state)
        },
        body: JSON.stringify(metric),
        keepalive: true
    }).catch(error => logger.warn(`Error sending web vital report ${error}`));
};

export default sendWebVitalReport;
